import ABCyaLib from '@abcya/abcya_lib';

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    gameMode: null, // null to allow the user to choose, or analog/digital
    levelsOverride: [ // if set to null, the user will play the original levels, otherwise set to an array that contains data about the levels to be played
      {
        level: null, // if set, will use that levels question generation, setting this will override all other settings
        // if there are more than one option that is "not null", one of the options will be picked at random to use per question
        allowedMinutes: null, // can be an array of minute values that are allowed, or null to allow any minute
        interval: null, // indicates what interval of minutes are allowed (for example, 5 to allow every 5 minutes). or null to allow any minute
      }
    ],
    subtitleKey: null,
    analogTimeLabelY: 81
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
    case 'digital-clocks-a': // 1st grade
      config.gameMode = 'digital';
      config.levelsOverride = [
        { allowedMinutes: [0] },
        { allowedMinutes: [30] },
        { allowedMinutes: [0,30] },
      ];
      config.subtitleKey = 'subtitle_variants.digital';
      break;
    case 'analog-clocks-a': // 1st grade
      config.gameMode = 'analog';
      config.levelsOverride = [
        { allowedMinutes: [0] },
        { allowedMinutes: [30] },
        { allowedMinutes: [0,30] },
      ];
      config.subtitleKey = 'subtitle_variants.analog';
      break;
    case 'digital-clocks-b': // 2nd grade
      config.gameMode = 'digital';
      config.levelsOverride = [
        { allowedMinutes: [0, 30] },
        { interval: 5 },
        { allowedMinutes: [0,30], interval: 5 },
      ];
      config.subtitleKey = 'subtitle_variants.digital';
      break;
    case 'analog-clocks-b': // 2nd grade
      config.gameMode = 'analog';
      config.levelsOverride = [
        { allowedMinutes: [0, 30] },
        { interval: 5 },
        { allowedMinutes: [0,30], interval: 5 },
      ];
      config.subtitleKey = 'subtitle_variants.analog';
      break;
    case 'digital-clocks-c': // 3rd grade
    case 'digital-clocks-d': // 4th grade
      config.gameMode = 'digital';
      config.levelsOverride = [
        { interval: 1 },
        { level: 3 },
        { level: 4 },
      ];
      config.subtitleKey = 'subtitle_variants.digital';
      break;
    case 'analog-clocks-c': // 3rd grade
    case 'analog-clocks-d': // 4th grade
      config.gameMode = 'analog';
      config.levelsOverride = [
        { interval: 1 },
        { level: 3 },
        { level: 4 },
      ];
      config.subtitleKey = 'subtitle_variants.analog';
      break;
    default:
      config.levelsOverride = null;
      break;
  }

  switch (locale) {
    case ABCyaLib.Environment.LOCALES.esUS:
      config.analogTimeLabelY = 78;
      break;
  }

  return config;
}